
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Rating, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Checkbox, Popup, Icon, Segment} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Tabla from "../common/ManageTabla";
import CurrencyInput from 'react-currency-input-field';
import { DatePicker, Space } from 'antd';
//import "antd/dist/antd.css";
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
import dayjs from 'dayjs';
const dateFormat = 'DD/MM/YYYY';

const CursoForm=({ id, color, form, usuarioCombo, tagCombo, cursoCombo, onSave,
                  headersTablaModulos, camposTablaModulos, moduloCombo, 
                  validacionesTablaModulos, onChange, archivos, onChangeCurrency, verModulo, 
                  tipoTablaModulos, ajaxCallInProgress, datos, errors={}, strings, permisos, fechas, onBuscar})=>{
    
    
	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["Curso"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.titulo}>            
                              <label  >{strings?strings["titulo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["titulo"]:""} 
                                    name="titulo"
                                    onChange={onChange}
                                    value={datos.titulo}
                                    icon='edit'/>
                            </Form.Field>
                                  
        
                            <Form.Field  required  error={errors.costo}>            
                              <label  >{strings?strings["costo"]:""}</label>
                              <CurrencyInput
                                  id="costo"
                                  name="costo"
                                    prefix="$"
                                  placeholder={strings?strings["costo"]:""} 

                                  decimalsLimit={2}
                                    value={datos.costo}
                                  onValueChange={(value, name) => onChangeCurrency(value, name)}
                                />
                            </Form.Field>
                                
                            <Form.Field  required  error={errors.cantidadModulos}>            
                              <label  >{strings?strings["cantidadModulos"]:""}</label>
                              <Input
                                  name="cantidadModulos"
                                  placeholder={strings?strings["cantidadModulos"]:""} 
                                  value={datos.cantidadModulos}
                                  onChange={onChange}
                                />
                            </Form.Field>
                                
                            <Form.Field  required  error={errors.horasTotales}>            
                              <label  >{strings?strings["horasTotales"]:""}</label>
                              <Input
                                  name="horasTotales"
                                  placeholder={strings?strings["horasTotales"]:""} 
                                  value={datos.horasTotales}
                                  onChange={onChange}
                                />
                            </Form.Field>
                                

                            <Form.Field required>
                                <label  >{strings?strings["fechaInicioCurso"]:""}</label>  
                                <DatePicker bordered={false}
                                        defaultValue={dayjs(datos.fechaInicio, dateFormat)}    
                                        onChange={(dates, dateStrings)=>fechas(dates, dateStrings)} 
                                        locale={locale} 
                                        size="large" 
                                        value={dayjs(datos.fechaInicio, dateFormat)}
                                        format={dateFormat} />
                                        
                                        
                            
                            </Form.Field>    
                                
                            
                            <Form.Field  required  error={errors.constanciaAutomatica}>
                              <label  >{strings?strings["constanciaAutomatica"]:""}</label>
                                    <Checkbox 
                                        slider 
                                        name="constanciaAutomatica"
                                        size="mini" 
                                        checked={datos.constanciaAutomatica==1? true:false}  
                                        onClick={onChange} 
                                        />
        
        
                
                            </Form.Field>


                            {datos.constanciaAutomatica?
                                <>
                                 <Form.Field  required  error={errors.numeroActividades}>            
                                      <label  >{strings?strings["numeroActividades"]:""}</label>
                                      <Input
                                          name="numeroActividades"
                                          placeholder={strings?strings["numeroActividades"]:""} 
                                          value={datos.numeroActividades}
                                          onChange={onChange}
                                        />
                                    </Form.Field>
                                        
                                    <Form.Field  required  error={errors.avanceVideosMinimo}>            
                                      <label  >{strings?strings["avanceVideosMinimo"]:""}</label>
                                      <Input
                                          name="avanceVideosMinimo"
                                          placeholder={strings?strings["avanceVideosMinimo"]:""} 
                                          value={datos.avanceVideosMinimo}
                                          onChange={onChange}
                                        />
                                    </Form.Field>    
                                 </>       
                                  
                                
                                :
                                ""
                                
                            }
                                        


                            <Form.Field  required  error={errors.descripcionCorta}>            
                              <label  >{strings?strings["descripcionCorta"]:""}</label>
                              <TextArea 
                                    placeholder={strings?strings["descripcionCorta"]:""} 
                                    name="descripcionCorta"
                                    onChange={onChange}
                                    value={datos.descripcionCorta}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.descripcionLarga}>            
                              <label  >{strings?strings["descripcionLarga"]:""}</label>
                              <TextArea 
                                    placeholder={strings?strings["descripcionLarga"]:""} 
                                    name="descripcionLarga"
                                    onChange={onChange}
                                    value={datos.descripcionLarga}
                                    icon='edit'/>
                            </Form.Field>
                                    
                                    
                             <Form.Field  required  error={errors.avancePermitido}>
                              <label  >{strings?strings["permitirAvanceVideo"]:""}</label>
                                    <Checkbox 
                                        slider 
                                        name="avancePermitido"
                                        size="mini" 
                                        checked={datos.avancePermitido==1? true:false}  
                                        onClick={onChange} 
                                        />
        
        
                
                            </Form.Field>        
                                            
                            
                            <Form.Field  required  error={errors.prefijo}>            
                                          <label  >{strings?strings["prefijo"]:""}</label>
                                          <Input 
                                                placeholder={strings?strings["prefijo"]:""} 
                                                name="prefijo"
                                                onChange={onChange}
                                                value={datos.prefijo}
                                                icon='edit'/>
                            </Form.Field>

                            <Button  color="black"
                                onClick={onBuscar}>{strings?strings["buscar"]:""}
                             </Button>    
                                    
                                    
                                    
                            <Form.Field  required  error={errors.imagenBanner}>
                              <label  >{strings?strings["imagenBanner"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["imagenBanner"]:""} 
                                    name="imagenBanner"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.imagenBanner}
                                    options={archivos}/>
                            </Form.Field>
        
         
                                
                            <Form.Field  required  error={errors.imagenThumbnails}>
                              <label  >{strings?strings["imagenThumbnails"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["imagenThumbnails"]:""} 
                                    name="imagenThumbnails"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.imagenThumbnails}
                                    options={archivos}/>
                            </Form.Field>
                                    
                                    
                            <Form.Field  required  error={errors.imagenThumbnails}>
                              <label  >{strings?strings["imagenBannerPresentacion"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["imagenBannerPresentacion"]:""} 
                                    name="imagenBannerPresentacion"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.imagenBannerPresentacion}
                                    options={archivos}/>
                            </Form.Field>        
        
        
                            <Form.Field  required  error={errors.idsInstructores}>
                              <label  >{strings?strings["idsInstructores"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsInstructores"]:""} 
                                    name="idsInstructores"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsInstructores}
                                    options={usuarioCombo}/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.idsTags}>
                              <label  >{strings?strings["idsTags"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsTags"]:""} 
                                    name="idsTags"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsTags}
                                    options={tagCombo}/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.idsCursosPreviosOpcinales}>
                              <label  >{strings?strings["idsCursosPreviosOpcinales"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsCursosPreviosOpcinales"]:""} 
                                    name="idsCursosPreviosOpcinales"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsCursosPreviosOpcinales}
                                    options={cursoCombo}/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.idsCursosPreviosObligatorios}>
                              <label  >{strings?strings["idsCursosPreviosObligatorios"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsCursosPreviosObligatorios"]:""} 
                                    name="idsCursosPreviosObligatorios"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsCursosPreviosObligatorios}
                                    options={cursoCombo}/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.idFiscalCasaMatriz}>
                                <label  >{strings?strings["idsModulos"]:""}
                                 </label>
                            </Form.Field>
                                 
                                <Grid>
                                    <Grid.Row>
                                    <Grid.Column  width={16}>    
                                        <Link to={"/modulo/"}> 
                                         <Popup
                                            trigger={<Icon  name='add' link   size="large"  color="tela" ></Icon>}
                                            content='Agregar nuevo módulo'

                                          />
                                         </Link>
                                        </Grid.Column>
                                    </Grid.Row>             
                                 </Grid>                 
                                <Form.Field>                     
                                <Tabla 
                                    verModulo={verModulo}
                                    tipoTablaModulos={tipoTablaModulos}
                                    combo={moduloCombo}
                                    nombre="idsModulos"
                                    headers={headersTablaModulos}
                                    campos={camposTablaModulos}
                                    validaciones={validacionesTablaModulos}
                                />  
                               
                            </Form.Field>
        
        
                            <Form.Field  required  error={errors.calificacion}>            
                              <label  >{strings?strings["calificacion"]:""}</label>
                              
                                <Rating icon='star' 
                                        defaultRating={4} 
                                        maxRating={5} 
                                        name="calificacion"
                                    onChange={onChange}
                                    value={datos.calificacion}
                                />
        
                            </Form.Field>
                                  
        
                            <Form.Field  required  error={errors.idsCursosSimilares}>
                              <label  >{strings?strings["idsCursosSimilares"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsCursosSimilares"]:""} 
                                    name="idsCursosSimilares"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsCursosSimilares}
                                    options={cursoCombo}/>
                            </Form.Field>
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/cursoscat">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default CursoForm;